module.exports = __webpack_public_path__ + "static/media/ro.625aca9e.svg";